import DocsConfig from '@tencent/docs-config';
const appConfigInstance = DocsConfig.getInstance();
const npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
let p = (!!npmConfig && npmConfig.CDN_ORIGIN) || 'https://docs.gtimg.com/docs-design-resources';
p = p + '/cooperation/ai/template/template_ppt_techno_silky_pink/'
export function getTemplateThumbnail1() { return p+'template_thumbnail_1-17a7576bfa.png'; };
export function getTemplateThumbnail10() { return p+'template_thumbnail_10-bde4a16056.png'; };
export function getTemplateThumbnail2() { return p+'template_thumbnail_2-4308e5fb77.png'; };
export function getTemplateThumbnail3() { return p+'template_thumbnail_3-2a9679694a.png'; };
export function getTemplateThumbnail4() { return p+'template_thumbnail_4-af0285afb7.png'; };
export function getTemplateThumbnail5() { return p+'template_thumbnail_5-93bc77baa7.png'; };
export function getTemplateThumbnail6() { return p+'template_thumbnail_6-f40aa6a444.png'; };
export function getTemplateThumbnail7() { return p+'template_thumbnail_7-9b44ace31d.png'; };
export function getTemplateThumbnail8() { return p+'template_thumbnail_8-938b8488bd.png'; };
export function getTemplateThumbnail9() { return p+'template_thumbnail_9-9b597516f7.png'; };
